import { useSelector } from 'react-redux';

import {
	selectTeams,
	selectAuthenticationContext,
} from '../selectors/authenticationContext.selectors';

export const useTeams = () => {
	const teams = useSelector(selectTeams);
	const { defaultSite } = useSelector(selectAuthenticationContext);

	const activeTeam = teams.find(team => team.tenantId === defaultSite);

	const alternateTeams = teams.filter(team => team.tenantId !== defaultSite);

	return {
		teams,
		activeTeam,
		alternateTeams,
	};
};
